/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyle } from '../styles/global-styles';
import { Data } from './pages/Loadable';
import '../styles/tailwind.css';

export function App() {
  return (
    <BrowserRouter>
      <Helmet
        titleTemplate="%s - Prison Telecom Data Project"
        defaultTitle="Prison Telecom Data Project"
      >
        <meta name="description" content="Prison Telecom Data Project" />
        <link rel="stylesheet" href="https://use.typekit.net/pmp5dsj.css" />
      </Helmet>

      <Data />

      <GlobalStyle />
    </BrowserRouter>
  );
}
